export default {
  props: [
    {
      attr: 'orgName',
      name: '所属校区'
    },
    {
      attr: 'packageNo',
      name: '课程包ID'
    },
    {
      attr: 'userName',
      name: '消费学生'
    },
    {
      attr: 'dealStatus',
      name: '消费状态'
    },
    {
      attr: 'createTime',
      name: '申请时间',
      slot: 'createTime',
      sortable: true
    },
    {
      attr: 'dealTime',
      name: '处理时间',
      slot: 'dealTime',
      sortable: true
    },
    {
      attr: 'applyReason',
      name: '申请理由'
    },
    {
      attr: 'refuseReason',
      name: '驳回理由'
    }
  ]
}
